<div>
    <ul>
        <li>Menu Item1</li>
        <li>Menu Item2</li>
        <li>Menu Item3</li>
        <li>Menu Item4</li>
        <li>Menu Item5</li>
        <li>Menu Item6</li>
    </ul>
</div>